import React from 'react'
import { useIntl } from 'react-intl'
import LoanDetailsContent from './LoanDetailsContent'
import withAuth from '../../../components/withAuth'
import LoanPage from '../../../components/LoanPage'

const LoanDetails = () => {
	const { formatMessage } = useIntl()
	return (
		<LoanPage
			page="app-loan-details"
			isFullWidth
			breadcrumbs={[
				{
					label: formatMessage({ id: 'breadcrumbs.details' }),
					value: 'details',
				},
			]}
		>
			<LoanDetailsContent />
		</LoanPage>
	)
}

export default withAuth(LoanDetails)
